import { render, staticRenderFns } from "./DialogDetailAccomodation.vue?vue&type=template&id=150ecc51&scoped=true&"
import script from "./DialogDetailAccomodation.vue?vue&type=script&lang=js&"
export * from "./DialogDetailAccomodation.vue?vue&type=script&lang=js&"
import style0 from "./DialogDetailAccomodation.vue?vue&type=style&index=0&id=150ecc51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ecc51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150ecc51')) {
      api.createRecord('150ecc51', component.options)
    } else {
      api.reload('150ecc51', component.options)
    }
    module.hot.accept("./DialogDetailAccomodation.vue?vue&type=template&id=150ecc51&scoped=true&", function () {
      api.rerender('150ecc51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyAccomodationsMobile/DialogDetailAccomodation.vue"
export default component.exports